import type {RelayCompat} from '@github-ui/server-persisted-queries/relay-compat'

import {LABELS} from '../constants/labels'
import type {IssueFieldAddedEventNode} from './issue-viewer-view-query-types'
import type {IssueFieldChangedEventFragment} from './IssueFieldChangedEvent'
import {IssueFieldEvent, type IssueFieldEventBaseProps, normalizeMultiSelectOption} from './IssueFieldEvent'
import type {IssueFieldRemovedEventFragment} from './IssueFieldRemovedEvent'
import {RolledupIssueFieldEvent} from './RolledupIssueFieldEvent'

type IssueFieldEventKey = IssueFieldAddedEventFragment | IssueFieldChangedEventFragment | IssueFieldRemovedEventFragment

// RELAY-CLEANUP(IssueFieldAddedEvent): widens nullable fields so still-Relay parent data is assignable.
// Remove when the timeline pagination fragments leave Relay.
export type IssueFieldAddedEventFragment = RelayCompat<
  Pick<
    IssueFieldAddedEventNode,
    'actor' | 'color' | 'createdAt' | 'databaseId' | 'intent' | 'issueField' | 'options' | 'value'
  >
>

type IssueFieldAddedEventProps = IssueFieldEventBaseProps & {
  queryRef: IssueFieldAddedEventFragment
  rollupGroup?: Record<string, IssueFieldEventKey[]>
}

export function IssueFieldAddedEvent({queryRef, rollupGroup, ...props}: IssueFieldAddedEventProps) {
  const {actor, createdAt, issueField, options, value: newValue, databaseId, color, intent} = queryRef
  const fieldOptions = options?.map(option => normalizeMultiSelectOption(option.name, option.color))

  const rollupContent = rollupGroup ? (
    <RolledupIssueFieldEvent rollupGroup={rollupGroup} repositoryNameWithOwner={props.repositoryNameWithOwner} />
  ) : undefined

  return (
    <IssueFieldEvent
      actor={actor}
      createdAt={createdAt}
      fieldName={issueField?.name}
      dataType={issueField?.dataType}
      fieldValue={newValue}
      fieldOptions={fieldOptions}
      color={color}
      databaseId={databaseId}
      leadingLabel={rollupGroup ? undefined : LABELS.timeline.issueFieldAdded.leading}
      trailingLabel={rollupGroup ? undefined : LABELS.timeline.issueFieldAdded.trailing}
      hasValue={!rollupGroup}
      rollupContent={rollupContent}
      rationale={rollupGroup ? undefined : (intent?.rationale ?? undefined)}
      analyticsAction="ISSUE_FIELD_ADDED"
      {...props}
    />
  )
}
